import { useAuthUserClaims } from './eventSubscribers';

const REQUIRED_ROLES = ['KYC', 'TOTP'];

export const useCanAddFunds = () => {
  const claims = useAuthUserClaims();
  return REQUIRED_ROLES.every(claim => claims?.roles.includes(claim));
};
